module.exports = __webpack_public_path__ + "static/media/7ba95726ef76f181e658ceb137277d2a9be17db2-26x24.0495a4eb.png";